import ArrowLineTool from './tools/ArrowLineTool';
import CrosshairTool from './tools/CrosshairTool';
import EllipseLineTool from './tools/EllipseLineTool';
import ExtendedLineTool from './tools/ExtendedLineTool';
import ExtendedHorizontalToolResistance from './tools/ExtendedHorizontalToolResistance';
import ExtendedHorizontalToolSupport from './tools/ExtendedHorizontalToolSupport';
import FibonacciArcTool from './tools/FibonacciArcTool';
import FibonacciCircleTool from './tools/FibonacciCircleTool';
import FibonacciFanTool from './tools/FibonacciFanTool';
import FibonacciLineTool from './tools/FibonacciLineTool';
import GannFanLineTool from './tools/GannFanLineTool';
import HorizontalLineTool from './tools/HorizontalLineTool';
import LineTool from './tools/LineTool';
import MeasurementLineTool from './tools/MeasurementLineTool';
import RayLineTool from './tools/RayLineTool';
import RectLineTool from './tools/RectLineTool';
import TextTool from './tools/TextTool';

export default {
	arrow: ArrowLineTool,
	crosshair: CrosshairTool,
	ellipse: EllipseLineTool,
	'extendedhorizontal-resistance': ExtendedHorizontalToolResistance,
	'extendedhorizontal-support': ExtendedHorizontalToolSupport,
	extended: ExtendedLineTool,
	fibonacci: FibonacciLineTool,
	fibarc: FibonacciArcTool,
	fibcircle: FibonacciCircleTool,
	fibfan: FibonacciFanTool,
	gannfan: GannFanLineTool,
	horizontal: HorizontalLineTool,
	line: LineTool,
	measurementline: MeasurementLineTool,
	ray: RayLineTool,
	rect: RectLineTool,
	text: TextTool
};
